import { useCreateMobileMoneyAccount } from "../../../../hooks/queries/useMerchantQueries";
import useModalManager from "./useModalManager";
import useAccountForm from "./useAccountForm";
import createAccountSubmitHandler from "../utils/accountSubmitHandler";

const useMobileMoneyHandlers = () => {
  const { modalState, openModal, closeModal } = useModalManager();
  const { mutate: createMobileMoneyAccount, isPending: mobileMoneyPending } =
    useCreateMobileMoneyAccount();
  const { control, handleSubmit, reset } = useAccountForm("mobile");

  const handleCloseModal = () => {
    closeModal("mobile");
    reset();
  };

  const onSubmit = createAccountSubmitHandler(
    createMobileMoneyAccount,
    (accountData) => accountData,
    () => {
      closeModal("mobile");
      reset();
    },
    "mobile",
  );

  return {
    modalOpened: modalState.mobile,
    openModal: () => openModal("mobile"),
    closeModal: handleCloseModal,
    handleSubmit: handleSubmit(onSubmit),
    control,
    isSubmitting: mobileMoneyPending,
  };
};

export default useMobileMoneyHandlers;
